var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full"},[(_vm.list && _vm.APIs)?_c('HybridList',{staticClass:"full",attrs:{"list":_vm.list,"APIs":_vm.APIs},on:{"loadmore":_vm.onLoadMore,"select":_vm.onSelect}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }